// extracted by mini-css-extract-plugin
module.exports = {"ModalFix":"ModalFix"};